import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <img src="/logo.png" alt="Doctors Lab Logo" className="logo" />
        </Link>
        <nav className="header-nav">
          <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>Home</Link>
          <Link to="/resources" className={`nav-link ${isActive('/resources') ? 'active' : ''}`}>Resources</Link>
          <Link to="/contact" className={`nav-link ${isActive('/contact') ? 'active' : ''}`}>Contact Us</Link>
        </nav>
        <div className="header-right">
          <a 
            href="https://drslab.careevolve.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="lab-portal-button"
          >
            Lab Portal
          </a>
          <a 
            href="https://marketplace.pointclickcare.com/s/partner-app/aFCPe000000IhEWOA0/doctors-lab" 
            target="_blank" 
            rel="noopener noreferrer"
            className="pcc-link"
          >
            <img src="/pcc.png" alt="PCC" className="pcc-image" />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;

